// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavBarAdmin_container__dM7VX {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ---------------------------navbar------------------------------ */

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl {
  animation: NavBarAdmin_init2__-TuGH 1s;
  width: 20vw;
  left: -15%;
  transition: 0.5s;
  display: flex;
  position: fixed;
  height: 100vh;
  overflow-y: hidden;
  border-radius: 0 25px 25px 0;
  box-shadow: 11px 0 31px -13px rgba(0, 0, 0, 0.286);
  z-index: 40;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navContent__EEYaj {
  width: 82%;
  transition: 0.3s;
  overflow-x: hidden;
  overflow-y: auto;
  margin-right: 10px;
  padding-bottom: 50px;
  scrollbar-color: rgba(50, 83, 72, 0) rgba(93, 93, 93, 0);
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navContent__EEYaj::-webkit-scrollbar {
  width: 3px;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navContent__EEYaj::-webkit-scrollbar-thumb {
  height: 50%;
  background-color: rgba(93, 93, 93, 0.09);
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_arrowNav__C4GWn {
  display: flex;
  width: 18%;
  justify-content: center;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_arrowNav__C4GWn .NavBarAdmin_arrowIcon__LRTul {
  transition: 0.5s;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  margin-right: 45px;
  width: 90%;
  rotate: 180deg;
  border-radius: 100%;
  height: 70px;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_arrowNav__C4GWn .NavBarAdmin_arrowIcon__LRTul:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(1.3);
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_open__eLO4b {
  left: 0;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_open__eLO4b .NavBarAdmin_arrowNav__C4GWn .NavBarAdmin_arrowIcon__LRTul {
  transition: 0.5s;
  rotate: 0deg;
  margin-right: 0;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_openarrow__\\+2Qcs {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  width: 100%;
  height: 50px;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_abaco_logo__LPiMd {
  margin-top: 20px;
  width: 80%;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_avatar__VfxDF {
  display: flex;
  width: 90%;
  margin-top: 20px;
  margin-bottom: 20px;
  justify-content: center;
  align-items: center;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_avatar__VfxDF .NavBarAdmin_profilepic__eg-3S {
  border: 10px solid rgba(165, 165, 165, 0.245);
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_avatar__VfxDF .NavBarAdmin_username__vhOwb {
  margin-left: 10px;
  font-size: 16px;
  font-family: Roboto, sans-serif;
  font-weight: 400;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_selector__KhCqk {
  width: 70%;
  height: 50px;
  margin-bottom: 30px;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_listItem__BI5G2 {
  text-decoration: none;
  width: 100%;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_itemContainer__VEzIj {
  margin-top: 9px;
  height: 40px;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_itemContainer__VEzIj .NavBarAdmin_listItem__BI5G2 .NavBarAdmin_itemButton__QSYnC {
  border-radius: 20px;
  width: 100%;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_itemContainer__VEzIj .NavBarAdmin_selectedItem__b-zsg {
  transition: 0.3s;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.135);
}
/* ---------------------------content------------------------------ */

.NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC {
  transition: 0.5s;
  margin-left: 5vw;
  width: 90vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_openContent__Pqflm {
  transition: 0.5s;
  margin-left: 20vw;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC .NavBarAdmin_headerPos__DVwAx {
  width: 100%;
  height: auto;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC .NavBarAdmin_headerPos__DVwAx .NavBarAdmin_mobileHeader__9m9mv {
  display: none;
  width: 100%;
}

.NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC .NavBarAdmin_outletPos__C9lYO {
  width: 100%;
  height: 85%;
}

@keyframes NavBarAdmin_init2__-TuGH {
  0% {
    opacity: 0;
    left: -40%;
  }
  100% {
    opacity: 1;
    left: -33%;
  }
}

@media screen and (max-width: 1300px) {
  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl {
    width: 20vw;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC {
    margin-left: 10vw;
    width: 90vw;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_openContent__Pqflm {
    margin-left: 20vw;
  }
}

@media screen and (max-width: 1100px) {
  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl {
    width: 30vw;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC {
    margin-left: 10vw;
    width: 90vw;
  }
}

@media screen and (max-width: 1000px) {
  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl {
    animation: NavBarAdmin_init2__-TuGH 1s;
    width: 40vw;
    left: -33%;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navContent__EEYaj {
    width: 85%;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_arrowNav__C4GWn {
    width: 15%;
    display: flex;
    justify-content: center;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_open__eLO4b {
    left: 0;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_open__eLO4b .NavBarAdmin_arrowNav__C4GWn .NavBarAdmin_arrowIcon__LRTul {
    transition: 0.5s;
    rotate: 0deg;
    margin-right: 0;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC {
    margin-left: 10vw;
    width: 90vw;
  }
}

@media screen and (max-width: 600px) {
  .NavBarAdmin_container__dM7VX {
    position: relative;
    flex-direction: column;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl {
    animation: none;
    width: 80vw;
    height: 100vh;
    top: 0;
    left: -80vw;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navContent__EEYaj {
    width: 100%;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_open__eLO4b {
    left: 0;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC {
    width: 100%;
    height: 100%;
    margin-left: 0;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC .NavBarAdmin_headerPos__DVwAx .NavBarAdmin_mobileHeader__9m9mv {
    display: flex;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC .NavBarAdmin_headerPos__DVwAx {
    width: 100%;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC .NavBarAdmin_headerPos__DVwAx .NavBarAdmin_webHeader__VQbIX {
    display: none;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC .NavBarAdmin_outletPos__C9lYO {
    margin-top: 20%;
  }
}

@media screen and (min-height: 700px) {
  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_itemContainer__VEzIj {
    margin-top: 5px;
    height: 50px;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_avatar__VfxDF .NavBarAdmin_profilepic__eg-3S {
    width: 60px;
    height: 60px;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_avatar__VfxDF .NavBarAdmin_username__vhOwb {
    font-size: 18px;
  }
}

@media screen and (min-height: 700px) {
  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_itemContainer__VEzIj {
    margin-top: 5px;
    height: 40px;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_avatar__VfxDF .NavBarAdmin_profilepic__eg-3S {
    width: 60px;
    height: 60px;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_avatar__VfxDF .NavBarAdmin_username__vhOwb {
    font-size: 18px;
  }
}

@media screen and (max-height: 600px) {
  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_abaco_logo__LPiMd {
    display: none;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_itemContainer__VEzIj {
    margin-top: 10px;
    height: 25px;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_avatar__VfxDF .NavBarAdmin_profilepic__eg-3S {
    width: 50px;
    height: 50px;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_avatar__VfxDF .NavBarAdmin_username__vhOwb {
    font-size: 16px;
  }
}

@media screen and (max-height: 550px) {
  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl {
    width: 22vw;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_content__33hSC {
    margin-left: 22vw;
    width: 78vw;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_itemContainer__VEzIj {
    margin-top: 14px;
    height: 25px;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_avatar__VfxDF {
    width: 90%;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_avatar__VfxDF .NavBarAdmin_profilepic__eg-3S {
    width: 50px;
    height: 50px;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_avatar__VfxDF .NavBarAdmin_username__vhOwb {
    font-size: 16px;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_navHeader__SNvgT .NavBarAdmin_selector__KhCqk {
    width: 80%;
    height: 40px;
    margin-bottom: 30px;
    margin-right: 5px;
  }

  .NavBarAdmin_container__dM7VX .NavBarAdmin_navbar__afatl .NavBarAdmin_itemContainer__VEzIj .NavBarAdmin_listItem__BI5G2 .NavBarAdmin_itemButton__QSYnC .NavBarAdmin_itemIcon__EmHLy {
    border-radius: 20px;
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation/NavBarAdmin/NavBarAdmin.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,oEAAoE;;AAEpE;EACE,sCAAmB;EACnB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;AACA,qEAAqE;;AAErE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;EACE;IACE,sCAAmB;IACnB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,aAAa;IACb,MAAM;IACN,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* ---------------------------navbar------------------------------ */\n\n.container .navbar {\n  animation: init2 1s;\n  width: 20vw;\n  left: -15%;\n  transition: 0.5s;\n  display: flex;\n  position: fixed;\n  height: 100vh;\n  overflow-y: hidden;\n  border-radius: 0 25px 25px 0;\n  box-shadow: 11px 0 31px -13px rgba(0, 0, 0, 0.286);\n  z-index: 40;\n}\n\n.container .navbar .navContent {\n  width: 82%;\n  transition: 0.3s;\n  overflow-x: hidden;\n  overflow-y: auto;\n  margin-right: 10px;\n  padding-bottom: 50px;\n  scrollbar-color: rgba(50, 83, 72, 0) rgba(93, 93, 93, 0);\n}\n\n.container .navbar .navContent::-webkit-scrollbar {\n  width: 3px;\n}\n\n.container .navbar .navContent::-webkit-scrollbar-thumb {\n  height: 50%;\n  background-color: rgba(93, 93, 93, 0.09);\n}\n\n.container .navbar .arrowNav {\n  display: flex;\n  width: 18%;\n  justify-content: center;\n}\n\n.container .navbar .arrowNav .arrowIcon {\n  transition: 0.5s;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 20px;\n  margin-right: 45px;\n  width: 90%;\n  rotate: 180deg;\n  border-radius: 100%;\n  height: 70px;\n}\n\n.container .navbar .arrowNav .arrowIcon:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(1.3);\n}\n\n.container .navbar .navHeader {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .open {\n  left: 0;\n}\n\n.container .open .arrowNav .arrowIcon {\n  transition: 0.5s;\n  rotate: 0deg;\n  margin-right: 0;\n}\n\n.container .navbar .openarrow {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n  width: 100%;\n  height: 50px;\n}\n\n.container .navbar .navHeader .abaco_logo {\n  margin-top: 20px;\n  width: 80%;\n}\n\n.container .navbar .navHeader .avatar {\n  display: flex;\n  width: 90%;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .navbar .navHeader .avatar .profilepic {\n  border: 10px solid rgba(165, 165, 165, 0.245);\n}\n\n.container .navbar .navHeader .avatar .username {\n  margin-left: 10px;\n  font-size: 16px;\n  font-family: Roboto, sans-serif;\n  font-weight: 400;\n}\n\n.container .navbar .navHeader .selector {\n  width: 70%;\n  height: 50px;\n  margin-bottom: 30px;\n}\n\n.container .navbar .listItem {\n  text-decoration: none;\n  width: 100%;\n}\n\n.container .navbar .itemContainer {\n  margin-top: 9px;\n  height: 40px;\n}\n\n.container .navbar .itemContainer .listItem .itemButton {\n  border-radius: 20px;\n  width: 100%;\n}\n\n.container .navbar .itemContainer .selectedItem {\n  transition: 0.3s;\n  border-radius: 10px;\n  background-color: rgba(0, 0, 0, 0.135);\n}\n/* ---------------------------content------------------------------ */\n\n.container .content {\n  transition: 0.5s;\n  margin-left: 5vw;\n  width: 90vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .openContent {\n  transition: 0.5s;\n  margin-left: 20vw;\n}\n\n.container .content .headerPos {\n  width: 100%;\n  height: auto;\n}\n\n.container .content .headerPos .mobileHeader {\n  display: none;\n  width: 100%;\n}\n\n.container .content .outletPos {\n  width: 100%;\n  height: 85%;\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    left: -40%;\n  }\n  100% {\n    opacity: 1;\n    left: -33%;\n  }\n}\n\n@media screen and (max-width: 1300px) {\n  .container .navbar {\n    width: 20vw;\n  }\n\n  .container .content {\n    margin-left: 10vw;\n    width: 90vw;\n  }\n\n  .container .openContent {\n    margin-left: 20vw;\n  }\n}\n\n@media screen and (max-width: 1100px) {\n  .container .navbar {\n    width: 30vw;\n  }\n\n  .container .content {\n    margin-left: 10vw;\n    width: 90vw;\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .container .navbar {\n    animation: init2 1s;\n    width: 40vw;\n    left: -33%;\n  }\n\n  .container .navbar .navContent {\n    width: 85%;\n  }\n\n  .container .navbar .arrowNav {\n    width: 15%;\n    display: flex;\n    justify-content: center;\n  }\n\n  .container .open {\n    left: 0;\n  }\n\n  .container .open .arrowNav .arrowIcon {\n    transition: 0.5s;\n    rotate: 0deg;\n    margin-right: 0;\n  }\n\n  .container .content {\n    margin-left: 10vw;\n    width: 90vw;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .container {\n    position: relative;\n    flex-direction: column;\n  }\n\n  .container .navbar {\n    animation: none;\n    width: 80vw;\n    height: 100vh;\n    top: 0;\n    left: -80vw;\n  }\n\n  .container .navbar .navContent {\n    width: 100%;\n  }\n\n  .container .open {\n    left: 0;\n  }\n\n  .container .content {\n    width: 100%;\n    height: 100%;\n    margin-left: 0;\n  }\n\n  .container .content .headerPos .mobileHeader {\n    display: flex;\n  }\n\n  .container .content .headerPos {\n    width: 100%;\n  }\n\n  .container .content .headerPos .webHeader {\n    display: none;\n  }\n\n  .container .content .outletPos {\n    margin-top: 20%;\n  }\n}\n\n@media screen and (min-height: 700px) {\n  .container .navbar .itemContainer {\n    margin-top: 5px;\n    height: 50px;\n  }\n\n  .container .navbar .navHeader .avatar .profilepic {\n    width: 60px;\n    height: 60px;\n  }\n\n  .container .navbar .navHeader .avatar .username {\n    font-size: 18px;\n  }\n}\n\n@media screen and (min-height: 700px) {\n  .container .navbar .itemContainer {\n    margin-top: 5px;\n    height: 40px;\n  }\n\n  .container .navbar .navHeader .avatar .profilepic {\n    width: 60px;\n    height: 60px;\n  }\n\n  .container .navbar .navHeader .avatar .username {\n    font-size: 18px;\n  }\n}\n\n@media screen and (max-height: 600px) {\n  .container .navbar .abaco_logo {\n    display: none;\n  }\n\n  .container .navbar .itemContainer {\n    margin-top: 10px;\n    height: 25px;\n  }\n\n  .container .navbar .navHeader .avatar .profilepic {\n    width: 50px;\n    height: 50px;\n  }\n\n  .container .navbar .navHeader .avatar .username {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-height: 550px) {\n  .container .navbar {\n    width: 22vw;\n  }\n\n  .container .content {\n    margin-left: 22vw;\n    width: 78vw;\n  }\n\n  .container .navbar .itemContainer {\n    margin-top: 14px;\n    height: 25px;\n  }\n\n  .container .navbar .navHeader .avatar {\n    width: 90%;\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n\n  .container .navbar .navHeader .avatar .profilepic {\n    width: 50px;\n    height: 50px;\n  }\n\n  .container .navbar .navHeader .avatar .username {\n    font-size: 16px;\n  }\n\n  .container .navbar .navHeader .selector {\n    width: 80%;\n    height: 40px;\n    margin-bottom: 30px;\n    margin-right: 5px;\n  }\n\n  .container .navbar .itemContainer .listItem .itemButton .itemIcon {\n    border-radius: 20px;\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NavBarAdmin_container__dM7VX`,
	"navbar": `NavBarAdmin_navbar__afatl`,
	"init2": `NavBarAdmin_init2__-TuGH`,
	"navContent": `NavBarAdmin_navContent__EEYaj`,
	"arrowNav": `NavBarAdmin_arrowNav__C4GWn`,
	"arrowIcon": `NavBarAdmin_arrowIcon__LRTul`,
	"navHeader": `NavBarAdmin_navHeader__SNvgT`,
	"open": `NavBarAdmin_open__eLO4b`,
	"openarrow": `NavBarAdmin_openarrow__+2Qcs`,
	"abaco_logo": `NavBarAdmin_abaco_logo__LPiMd`,
	"avatar": `NavBarAdmin_avatar__VfxDF`,
	"profilepic": `NavBarAdmin_profilepic__eg-3S`,
	"username": `NavBarAdmin_username__vhOwb`,
	"selector": `NavBarAdmin_selector__KhCqk`,
	"listItem": `NavBarAdmin_listItem__BI5G2`,
	"itemContainer": `NavBarAdmin_itemContainer__VEzIj`,
	"itemButton": `NavBarAdmin_itemButton__QSYnC`,
	"selectedItem": `NavBarAdmin_selectedItem__b-zsg`,
	"content": `NavBarAdmin_content__33hSC`,
	"openContent": `NavBarAdmin_openContent__Pqflm`,
	"headerPos": `NavBarAdmin_headerPos__DVwAx`,
	"mobileHeader": `NavBarAdmin_mobileHeader__9m9mv`,
	"outletPos": `NavBarAdmin_outletPos__C9lYO`,
	"webHeader": `NavBarAdmin_webHeader__VQbIX`,
	"itemIcon": `NavBarAdmin_itemIcon__EmHLy`
};
export default ___CSS_LOADER_EXPORT___;
